<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Initial Setup</v-toolbar-title>
          </v-toolbar>
          
          <v-card-text>
            <div class="text-center mb-4">
              <v-icon size="64" color="primary">mdi-account-plus</v-icon>
              <h3 class="mt-2">Welcome to Packlist Manager!</h3>
              <p class="text-body-2 mt-2">Create your admin account to get started.</p>
            </div>
            
            <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="setup">
              <v-text-field
                v-model="username"
                :rules="usernameRules"
                label="Admin Username"
                prepend-icon="mdi-account"
                required
                @keyup.enter="setup"
              ></v-text-field>
              
              <v-text-field
                v-model="password"
                :rules="passwordRules"
                label="Admin Password"
                prepend-icon="mdi-lock"
                type="password"
                required
                @keyup.enter="setup"
              ></v-text-field>
              
              <v-text-field
                v-model="confirmPassword"
                :rules="confirmPasswordRules"
                label="Confirm Password"
                prepend-icon="mdi-lock-check"
                type="password"
                required
                @keyup.enter="setup"
              ></v-text-field>
            </v-form>
          </v-card-text>
          
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="!valid || loading"
              :loading="loading"
              @click="setup"
            >
              Create Admin Account
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    
    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="5000">
      {{ snackbarText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'

export default {
  name: 'Setup',
  setup() {
    const router = useRouter()
    
    const valid = ref(false)
    const loading = ref(false)
    const username = ref('')
    const password = ref('')
    const confirmPassword = ref('')
    const snackbar = ref(false)
    const snackbarText = ref('')
    const snackbarColor = ref('error')
    
    const usernameRules = [
      v => !!v || 'Username is required',
      v => v.length >= 3 || 'Username must be at least 3 characters'
    ]
    
    const passwordRules = [
      v => !!v || 'Password is required',
      v => v.length >= 6 || 'Password must be at least 6 characters'
    ]
    
    const confirmPasswordRules = computed(() => [
      v => !!v || 'Password confirmation is required',
      v => v === password.value || 'Passwords do not match'
    ])
    
    const showMessage = (message, color = 'error') => {
      snackbarText.value = message
      snackbarColor.value = color
      snackbar.value = true
    }
    
    const setup = async () => {
      if (!valid.value) return
      
      loading.value = true
      
      try {
        await axios.post('/api/setup', {
          username: username.value,
          password: password.value
        })
        
        showMessage('Admin account created successfully! Redirecting to login...', 'success')
        
        // Redirect to login after showing success message
        setTimeout(() => {
          router.push('/login')
        }, 1500)
        
      } catch (error) {
        const errorMessage = error.response?.data?.detail || 'Setup failed. Please try again.'
        showMessage(errorMessage)
      } finally {
        loading.value = false
      }
    }
    
    return {
      valid,
      loading,
      username,
      password,
      confirmPassword,
      usernameRules,
      passwordRules,
      confirmPasswordRules,
      snackbar,
      snackbarText,
      snackbarColor,
      setup
    }
  }
}
</script>